import { NumberInput } from "@mantine/core";
import type { EmblaCarouselType } from "embla-carousel";
import classes from "./CardTally.module.css";

export default function CardTally({
  embla,
  active,
  flashcardTally,
}: {
  embla: EmblaCarouselType | null;
  active: number;
  flashcardTally: number;
}) {
  return (
    <NumberInput
      aria-label="Flash card"
      hideControls
      min={1}
      max={flashcardTally + 1}
      onChange={(value) => embla?.scrollTo((value as number) - 1)}
      maw={"10ch"}
      size="sm"
      value={active}
      classNames={{
        input: classes.input,
        section: classes.section,
      }}
      suffix={active > flashcardTally ? " End" : `/${flashcardTally}`}
    />
  );
}
